import { createApp } from 'vue'
import Documents from './Documents.vue'

const el = document.querySelector('[data-app-investor-documents]')

if (el) {
  createApp(Documents).mount(el)
}
